import(/* webpackMode: "eager" */ "/var/www/azia_frontv2_green/.local-data/work/about-page-90b4e4781110d7f22fb5e744b5e213bd8cfae73d/build/src/app/error.tsx");
